<template>
  <q-dialog
    :model-value="modelValue"
    maximized
    persistent
    no-backdrop-dismiss
    no-esc-dismiss
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card class="iphone-top-splash column no-wrap">
      <q-card-section class="col flex flex-center q-pa-lg">
        <div class="iphone-top-splash__content">
          <q-icon name="contactless" size="56px" color="primary" class="q-mb-md" />
          <div class="text-h5 text-weight-medium q-mb-md">
            {{ t('iphoneTopMarketing.title') }}
          </div>
          <ul class="text-body1 q-pl-md q-mb-xl text-grey-9">
            <li>{{ t('iphoneTopMarketing.bulletContactless') }}</li>
            <li>{{ t('iphoneTopMarketing.bulletNoHardware') }}</li>
            <li>{{ t('iphoneTopMarketing.bulletFastCheckout') }}</li>
          </ul>
          <div class="column q-gutter-sm">
            <q-btn
              unelevated
              color="primary"
              size="lg"
              :label="t('iphoneTopMarketing.ctaSetup')"
              @click="onGetStarted"
            />
            <q-btn
              flat
              color="primary"
              :label="t('iphoneTopMarketing.ctaLater')"
              @click="onLater"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useIphoneTopEligibility } from '@/composables/useIphoneTopEligibility.js'
import { useIphoneTopMarketingAck } from '@/composables/useIphoneTopMarketingAck.js'
import { showIphoneTopAdminRequiredDialog } from '@/utils/iphoneTopAdminDialog.js'
import { useQuasar } from 'quasar'

defineProps({
  modelValue: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()
const router = useRouter()
const $q = useQuasar()
const { canOpenSetupWizard } = useIphoneTopEligibility()
const { persistMarketingAck } = useIphoneTopMarketingAck()

function closeSplash () {
  emit('update:modelValue', false)
}

function onLater () {
  persistMarketingAck('seen')
  closeSplash()
}

function onGetStarted () {
  persistMarketingAck('completed')
  closeSplash()
  if (!canOpenSetupWizard.value) {
    showIphoneTopAdminRequiredDialog($q, t)
    return
  }
  router.push({ name: 'settings-iphone-tap-to-pay' })
}
</script>

<style scoped lang="scss">
.iphone-top-splash {
  background: linear-gradient(165deg, #f0f4ff 0%, #ffffff 45%);
}

.iphone-top-splash__content {
  max-width: 420px;
  width: 100%;
}
</style>
